export type ClinicMapBounds = {
    swLat: number;
    swLng: number;
    neLat: number;
    neLng: number;
};

export function parseClinicMapBounds(
    input: Partial<ClinicMapBounds> | Record<string, unknown> | null | undefined,
): ClinicMapBounds | null {
    if (!input) {
        return null;
    }

    const swLat = Number(input.swLat);
    const swLng = Number(input.swLng);
    const neLat = Number(input.neLat);
    const neLng = Number(input.neLng);

    if (![swLat, swLng, neLat, neLng].every(Number.isFinite)) {
        return null;
    }

    if (swLat < -90 || neLat > 90 || swLat >= neLat) {
        return null;
    }

    if (Math.abs(swLng) > 180 || Math.abs(neLng) > 180 || swLng >= neLng) {
        return null;
    }

    return {swLat, swLng, neLat, neLng};
}

/** Яндекс.Карты: bounds = [[lng, lat], [lng, lat]]. */
export function clinicMapBoundsFromYandex(bounds: unknown): ClinicMapBounds | null {
    if (!Array.isArray(bounds) || bounds.length < 2) {
        return null;
    }

    const [first, second] = bounds;
    if (!Array.isArray(first) || !Array.isArray(second) || first.length < 2 || second.length < 2) {
        return null;
    }

    const lngs = [Number(first[0]), Number(second[0])];
    const lats = [Number(first[1]), Number(second[1])];

    return parseClinicMapBounds({
        swLat: Math.min(lats[0], lats[1]),
        swLng: Math.min(lngs[0], lngs[1]),
        neLat: Math.max(lats[0], lats[1]),
        neLng: Math.max(lngs[0], lngs[1]),
    });
}

export function isSameClinicMapBounds(
    a: ClinicMapBounds | null | undefined,
    b: ClinicMapBounds | null | undefined,
): boolean {
    if (!a || !b) {
        return a === b;
    }

    return a.swLat === b.swLat
        && a.swLng === b.swLng
        && a.neLat === b.neLat
        && a.neLng === b.neLng;
}
